"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _NavigationLink.default;
  }
});

var _NavigationLink = _interopRequireDefault(require("./NavigationLink"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }